// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.2/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================================================
   PHONE INPUT (intl-tel-input)
   ============================================================================= */

.PhoneInput-module__wrapper__O3kfC {
  position: relative;
}

.PhoneInput-module__wrapper__O3kfC .mantine-Input-wrapper {
  position: relative;
}

.PhoneInput-module__wrapper__O3kfC .PhoneInput-module__label__VW5Ru {
  position: absolute;
  top: 50%;
  left: 115px;
  transform: translateY(-50%);
  transition: all 0.15s ease;
  pointer-events: none;
  z-index: 1;
  background-color: transparent;
  padding: 0 var(--mantine-spacing-xs);
  font-size: var(--mantine-font-size-sm);
  color: var(--mantine-color-gray-6);
  text-transform: capitalize;
}

.PhoneInput-module__wrapper__O3kfC[data-has-value] .PhoneInput-module__label__VW5Ru,
.PhoneInput-module__wrapper__O3kfC:focus-within .PhoneInput-module__label__VW5Ru {
  top: -1px;
  left: var(--mantine-spacing-sm);
  transform: translateY(-50%);
  font-size: var(--mantine-font-size-xs);
  background-color: var(--mantine-color-white);
  color: var(--mantine-color-dark-6);
}

/* intl-tel-input wraps the field in its own container, which defaults to inline-block;
   the double class beats that rule so the field keeps the full width. */
.iti.PhoneInput-module__container__aJC6d,
.iti.PhoneInput-module__containerPlain__EzH0r {
  display: block;
  width: 100%;
}

/* intl-tel-input container */
.PhoneInput-module__container__aJC6d .iti__selected-country-primary {
  padding: 0 var(--mantine-spacing-sm);
  background: transparent;
  border-right: 1px solid var(--mantine-color-gray-4);
  margin-right: var(--mantine-spacing-xs);
}

.PhoneInput-module__container__aJC6d .iti__arrow {
  border-top-color: var(--mantine-color-gray-6);
  margin-left: var(--mantine-spacing-xs);
}

/* Same specificity as .wrapper .label, declared after it, so the floating label goes
   back to the normal left offset without the country selector. */
.PhoneInput-module__wrapper__O3kfC .PhoneInput-module__labelPlain__wO2Sm {
  left: var(--mantine-spacing-sm);
}

/* Country selector panel — border, shadow, radius */
.iti__country-selector {
  border-radius: var(--mantine-radius-md);
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1), 0 4px 6px rgba(0, 0, 0, 0.05);
  border: 1px solid var(--mantine-color-gray-3);
  overflow: hidden;
  z-index: 1000;
}

/* Hide search icon */
.iti__search-icon {
  display: none;
}

/* Search box in dropdown */
.iti__search-input {
  padding: var(--mantine-spacing-xs) var(--mantine-spacing-sm);
  border: none;
  border-bottom: 1px solid var(--mantine-color-gray-2);
  border-radius: 0;
  font-size: var(--mantine-font-size-sm);
  margin: 0;
  width: 100%;
}

.iti__search-input:focus {
  outline: none;
  border-bottom-color: var(--mantine-color-gray-4);
}

/* Country list — no border/shadow/radius (handled by outer box) */
.iti__country-list {
  border: none;
  box-shadow: none;
  border-radius: 0;
  max-height: 250px;
  scrollbar-width: none;
}

.iti__country-list::-webkit-scrollbar {
  display: none;
}

.iti__country-list .iti__country {
  padding: var(--mantine-spacing-xs) var(--mantine-spacing-sm);
  transition: background-color 0.15s ease;
}

.iti__country-list .iti__country:hover,
.iti__country-list .iti__country.iti__highlight {
  background-color: var(--mantine-color-gray-1);
}

.iti__country-list .iti__country.iti__active {
  background-color: var(--mantine-primary-color-light);
}

.iti__country-list .iti__country-name {
  font-size: var(--mantine-font-size-sm);
}

.iti__country-list .iti__dial-code {
  color: var(--mantine-color-gray-6);
}
`, "",{"version":3,"sources":["webpack://./../../packages/ui/src/components/form/PhoneInput/PhoneInput.module.css"],"names":[],"mappings":"AAAA;;kFAEkF;;AAElF;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,0BAA0B;EAC1B,oBAAoB;EACpB,UAAU;EACV,6BAA6B;EAC7B,oCAAoC;EACpC,sCAAsC;EACtC,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;;EAEE,SAAS;EACT,+BAA+B;EAC/B,2BAA2B;EAC3B,sCAAsC;EACtC,4CAA4C;EAC5C,kCAAkC;AACpC;;AAEA;wEACwE;AACxE;;EAEE,cAAc;EACd,WAAW;AACb;;AAEA,6BAA6B;AAC7B;EACE,oCAAoC;EACpC,uBAAuB;EACvB,mDAAmD;EACnD,uCAAuC;AACzC;;AAEA;EACE,6CAA6C;EAC7C,sCAAsC;AACxC;;AAEA;iEACiE;AACjE;EACE,+BAA+B;AACjC;;AAEA,oDAAoD;AACpD;EACE,uCAAuC;EACvC,yEAAyE;EACzE,6CAA6C;EAC7C,gBAAgB;EAChB,aAAa;AACf;;AAEA,qBAAqB;AACrB;EACE,aAAa;AACf;;AAEA,2BAA2B;AAC3B;EACE,4DAA4D;EAC5D,YAAY;EACZ,oDAAoD;EACpD,gBAAgB;EAChB,sCAAsC;EACtC,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gDAAgD;AAClD;;AAEA,kEAAkE;AAClE;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,4DAA4D;EAC5D,uCAAuC;AACzC;;AAEA;;EAEE,6CAA6C;AAC/C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;AACpC","sourcesContent":["/* =============================================================================\n   PHONE INPUT (intl-tel-input)\n   ============================================================================= */\n\n.wrapper {\n  position: relative;\n}\n\n.wrapper :global(.mantine-Input-wrapper) {\n  position: relative;\n}\n\n.wrapper .label {\n  position: absolute;\n  top: 50%;\n  left: 115px;\n  transform: translateY(-50%);\n  transition: all 0.15s ease;\n  pointer-events: none;\n  z-index: 1;\n  background-color: transparent;\n  padding: 0 var(--mantine-spacing-xs);\n  font-size: var(--mantine-font-size-sm);\n  color: var(--mantine-color-gray-6);\n  text-transform: capitalize;\n}\n\n.wrapper[data-has-value] .label,\n.wrapper:focus-within .label {\n  top: -1px;\n  left: var(--mantine-spacing-sm);\n  transform: translateY(-50%);\n  font-size: var(--mantine-font-size-xs);\n  background-color: var(--mantine-color-white);\n  color: var(--mantine-color-dark-6);\n}\n\n/* intl-tel-input wraps the field in its own container, which defaults to inline-block;\n   the double class beats that rule so the field keeps the full width. */\n:global(.iti).container,\n:global(.iti).containerPlain {\n  display: block;\n  width: 100%;\n}\n\n/* intl-tel-input container */\n.container :global(.iti__selected-country-primary) {\n  padding: 0 var(--mantine-spacing-sm);\n  background: transparent;\n  border-right: 1px solid var(--mantine-color-gray-4);\n  margin-right: var(--mantine-spacing-xs);\n}\n\n.container :global(.iti__arrow) {\n  border-top-color: var(--mantine-color-gray-6);\n  margin-left: var(--mantine-spacing-xs);\n}\n\n/* Same specificity as .wrapper .label, declared after it, so the floating label goes\n   back to the normal left offset without the country selector. */\n.wrapper .labelPlain {\n  left: var(--mantine-spacing-sm);\n}\n\n/* Country selector panel — border, shadow, radius */\n:global(.iti__country-selector) {\n  border-radius: var(--mantine-radius-md);\n  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1), 0 4px 6px rgba(0, 0, 0, 0.05);\n  border: 1px solid var(--mantine-color-gray-3);\n  overflow: hidden;\n  z-index: 1000;\n}\n\n/* Hide search icon */\n:global(.iti__search-icon) {\n  display: none;\n}\n\n/* Search box in dropdown */\n:global(.iti__search-input) {\n  padding: var(--mantine-spacing-xs) var(--mantine-spacing-sm);\n  border: none;\n  border-bottom: 1px solid var(--mantine-color-gray-2);\n  border-radius: 0;\n  font-size: var(--mantine-font-size-sm);\n  margin: 0;\n  width: 100%;\n}\n\n:global(.iti__search-input):focus {\n  outline: none;\n  border-bottom-color: var(--mantine-color-gray-4);\n}\n\n/* Country list — no border/shadow/radius (handled by outer box) */\n:global(.iti__country-list) {\n  border: none;\n  box-shadow: none;\n  border-radius: 0;\n  max-height: 250px;\n  scrollbar-width: none;\n}\n\n:global(.iti__country-list)::-webkit-scrollbar {\n  display: none;\n}\n\n:global(.iti__country-list) :global(.iti__country) {\n  padding: var(--mantine-spacing-xs) var(--mantine-spacing-sm);\n  transition: background-color 0.15s ease;\n}\n\n:global(.iti__country-list) :global(.iti__country):hover,\n:global(.iti__country-list) :global(.iti__country.iti__highlight) {\n  background-color: var(--mantine-color-gray-1);\n}\n\n:global(.iti__country-list) :global(.iti__country.iti__active) {\n  background-color: var(--mantine-primary-color-light);\n}\n\n:global(.iti__country-list) :global(.iti__country-name) {\n  font-size: var(--mantine-font-size-sm);\n}\n\n:global(.iti__country-list) :global(.iti__dial-code) {\n  color: var(--mantine-color-gray-6);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `PhoneInput-module__wrapper__O3kfC`,
	"label": `PhoneInput-module__label__VW5Ru`,
	"container": `PhoneInput-module__container__aJC6d`,
	"containerPlain": `PhoneInput-module__containerPlain__EzH0r`,
	"labelPlain": `PhoneInput-module__labelPlain__wO2Sm`
};
module.exports = ___CSS_LOADER_EXPORT___;
